/**
 * Draws a loaded HTMLImageElement onto a canvas and returns a static PNG data URL.
 * Returns null when the canvas is tainted (CORS) or dimensions are empty.
 */
export function captureGifFreezeFrame(img: HTMLImageElement): string | null {
  const { naturalWidth: width, naturalHeight: height } = img;
  if (!width || !height) return null;

  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d');
  if (!ctx) return null;

  try {
    ctx.drawImage(img, 0, 0, width, height);
    return canvas.toDataURL('image/png');
  } catch {
    return null;
  }
}

/** Loads `url` (CORS) and returns a freeze-frame data URL, or null on failure. */
export function loadGifFreezeFrame(url: string): Promise<string | null> {
  return new Promise(resolve => {
    const img = new window.Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => resolve(captureGifFreezeFrame(img));
    img.onerror = () => resolve(null);
    img.src = url;
  });
}
